<template>
    <div class="form-group products-select">
        <select
            v-model="top_category_id"
            class="form-control products-select__category"
            @input="topCategoryChanged"
            v-if="topCategories"
        >
            <option :value="null">
                Select Category
            </option>
            <option
                v-for="category in topCategories"
                :key="category.id"
                :value="category.id"
            >
                {{ category.name }}
            </option>
        </select>

        <select
            v-model="category_id"
            class="form-control products-select__category"
            @input="categoryChanged"
            v-if="childCategories"
            :disabled="childCategories.length < 1"
        >
            <option :value="null">
                Select Category
            </option>
            <option
                v-for="category in childCategories"
                :key="category.id"
                :value="category.id"
            >
                {{ category.name }}
            </option>
        </select>

        <select
            @input="emitInput"
            class="form-control products-select__product"
            v-if="products"
            :value="type === 'object' && value !== null ? value.id : value"
        >
            <option :value="null">
                Select Product
            </option>
            <option
                v-for="product in filteredProducts"
                :key="product.id"
                :value="product.id"
                :selected="optionSelected(product)"
            >
                {{ product.name }} - {{ product.code }}
            </option>
        </select>
    </div>
</template>
<script>
import ProductService from '../services/ProductsService';
import ProductCategoriesService from '../services/ProductCategoriesService';
export default {
    props: {
        value: {
            default: null,
            type: [String, Number, Object],
        },
        type: {
            default: 'id',
            type: String,
        },
        customerId: {
            default: null,
            type: [String, Number],
        },
    },
    data () {
        return {
            top_category_id: null,
            category_id: null,
            categories: [],
            products: [],
        };
    },
    computed: {
        filteredProducts () {
            if (!this.category_id && !this.top_category_id) {
                return this.products;
            }

            return this.products.filter(p => {
                if (this.category_id) {
                    if (p.category_id === parseInt(this.category_id)) {
                        return true;
                    }
                    return false;
                }
                return p.category_id === parseInt(this.top_category_id) || (this.childCategories.findIndex(c => c.id === p.category_id) >= 0);
            });
        },
        topCategories () {
            return this.categories.filter(c => !c.parent_id);
        },
        childCategories () {
            return this.categories.filter(c => c.parent_id === parseInt(this.top_category_id));
        }
    },
    watch: {
        customerId: function () {
            this.loadProducts();
        },
    },
    created () {
        this.loadProducts();
        this.loadCategories();
    },
    methods: {
        loadProducts() {
            ProductService.index({ customer_id: this.customerId }).then(({data}) => {
                this.products = data;
                this.$forceUpdate();
            });
        },
        loadCategories() {
            ProductCategoriesService.index().then(({data}) => {
                this.categories = data;
                this.$forceUpdate();
            });
        },
        emitInput(event) {
            let value = event.target.value;
            if (this.type === 'object' && value !== null) {
                value = this.products.find(p => p.id === parseInt(value));
            }
            this.$emit('input', value);
        },
        topCategoryChanged () {
            this.category_id = null;
            if (!this.top_category_id) {
                return;
            }
            this.$emit('input', null);
        },
        categoryChanged () {
            if (!this.category_id) {
                return;
            }
            this.$emit('input', null);
        },

        optionSelected (product) {
            if (!this.value) {
                return false;
            }
            return this.type === 'object' ? parseInt(this.value.id) === parseInt(product.id) : parseInt(this.value) === parseInt(product.id)
        }
    },
}
</script>
<style lang="scss" scoped>
    .products-select {
        display: flex;

        &__category {
            max-width: 14rem;
            margin-right: .5rem;
        }

        &__product {
            max-width: 32rem;
        }
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/ProductsSelectComponent.vue